module.exports = __webpack_public_path__ + "img/x.84b1e9ef.svg";